function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 4C3 6.20914 4.79086 8 7 8C8.06087 8 9.07828 7.57857 9.82843 6.82843C10.5786 6.07828 11 5.06087 11 4C11 1.79086 9.20914 0 7 0C4.79086 0 3 1.79086 3 4ZM5 4C5 2.89543 5.89543 2 7 2C7.53043 2 8.03914 2.21071 8.41421 2.58579C8.78929 2.96086 9 3.46957 9 4C9 5.10457 8.10457 6 7 6C5.89543 6 5 5.10457 5 4Z",
  fill: "#F8D635"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.90601 30.2001C4.0091 31.2259 4.87506 32.0052 5.90601 32H8.09401C9.12191 32.0011 9.98322 31.2228 10.086 30.2001L10.906 22.0001H12C12.2835 22.0015 12.5543 21.8825 12.745 21.6727C12.9357 21.463 13.0284 21.1821 13 20.9001L12.096 11.8001C11.9929 10.7742 11.127 9.99488 10.096 10.0001H9.00001C8.73462 9.99958 8.47991 10.1046 8.29201 10.2921L7.00001 11.5841L5.70801 10.2921C5.52011 10.1046 5.26541 9.99958 5.00001 10.0001H3.91601C2.88506 9.99488 2.0191 10.7742 1.91601 11.8001L1.00001 20.9001C0.971661 21.1821 1.06436 21.463 1.25506 21.6727C1.44576 21.8825 1.71653 22.0015 2.00001 22.0001H3.09401L3.90601 30.2001ZM4.00001 20.0001H3.10601L3.90601 12.0001H4.58601L6.29401 13.7081C6.69091 14.0827 7.31112 14.0827 7.70801 13.7081L9.41401 12.0001H10.094L10.894 20.0001H10C9.48454 19.9975 9.05156 20.3871 9.00001 20.9001L8.09401 30.0001H5.90601L5.00001 20.9001C4.94847 20.3871 4.51549 19.9975 4.00001 20.0001Z",
  fill: "#F8D635"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9999 12.0002C16.6399 12.0002 16.2799 12.0002 15.9399 11.9782L16.0619 9.97823C16.3619 10.0002 16.6919 10.0002 16.9999 10.0002C21.2823 10.0131 25.5193 9.12238 29.4339 7.38623L30.2459 9.21423C26.0757 11.0643 21.5621 12.0136 16.9999 12.0002Z",
  fill: "#F8D635"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.434 24.6141C25.4921 22.8903 21.2363 22.0003 16.934 22.0001C16.638 22.0001 16.334 22.0001 16.06 22.0181L15.938 20.0181C16.28 20.0001 16.64 20.0001 17 20.0001C21.5621 19.9868 26.0758 20.9361 30.246 22.7861L29.434 24.6141Z",
  fill: "#F8D635"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.882 31.934C16.253 31.9784 16.6263 32.0005 17 32C25.8366 32 33 24.8366 33 16C33 7.16346 25.8366 1.24986e-05 17 1.24986e-05C16.6263 -0.000423381 16.253 0.0216164 15.882 0.0660125L15 0.170012V31.83L15.882 31.934ZM31 16C31 23.732 24.732 30 17 30V2.00001C24.732 2.00001 31 8.26803 31 16Z",
  fill: "#F8D635"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.642 31.7659L16.356 30.2319C20.5663 26.7035 22.9984 21.4922 22.9984 15.9989C22.9984 10.5056 20.5663 5.29423 16.356 1.76589L17.642 0.233887C22.3059 4.14261 25 9.91563 25 16.0009C25 22.0861 22.3059 27.8592 17.642 31.7679V31.7659Z",
  fill: "#F8D635"
});

var SvgBenefits4 = function SvgBenefits4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBenefits4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/benefits4.041dc4a7.svg";
export { ForwardRef as ReactComponent };